module.exports = __webpack_public_path__ + "img/4.11e84c49.jpg";